<template lang="pug">
#outing-detail
  //- title
  .d-flex.flex-row.justify-content-center.mb-1(v-if="outing")
    .page-title
      span {{ _typeName }}届け出編集

  .mb-3.separator(v-if="outing")

  .content(v-if="outing")
    //- resident
    .mb-0
      span.key-name 利用者名（部屋名）
    .mb-3
      span {{ outing.targetResidentInfo.name }}（{{ outing.targetResidentInfo.roomName }}）

    //- status
    .mb-0
      span.key-name 状態
    .mb-3
      span.status-no-consented(v-if="outing.consented == false") 未承諾（{{ _inputType }}）
      span.status-consented(v-else) 承諾済（{{ _inputType }}）

    //- start datetime
    .mb-1
      span.key-name 開始日時
      RequireInput
    .mb-3
      .d-flex.flex-column(v-if="outing.type == 'goingOut' || outing.type == 'stayingOut'")
        .d-flex.flex-row.align-items-center.flex-wrap
          b-form-select.mr-1.mb-2(v-model="startYear" :options="_startYearOptions" style="max-width: 160px;")
          span.mr-1 年
          b-form-select.mr-1.mb-2(v-model="startMonth" :options="startMonthOptions" style="max-width: 70px;")
          span.mr-1 月
          b-form-select.mr-1.mb-2(v-model="startDate" :options="startDateOptions" style="max-width: 70px;")
          span.mr-1 日
          b-form-select.mr-1.mb-2(v-model="startHour" :options="startHourOptions" style="max-width: 70px;")
          span.mr-1 時
          b-form-select.mr-1.mb-2(v-model="startMin" :options="startMinOptions" style="max-width: 70px;")
          span.mr-1 分
      .error-messages.mt-1(v-if="0 < outingDateErrorMessages.length")
        label.error-message(v-for="error in outingDateErrorMessages") {{ error }}

    //- end datetime
    .mb-1
      span.key-name 終了日時
      RequireInput
    .mb-3
      .d-flex.flex-column(v-if="outing.type == 'goingOut'")
        .d-flex.flex-row.align-items-center.flex-wrap
          b-form-select.mr-1.mb-2(v-model="endHour" :options="endHourOptions" style="max-width: 70px;")
          span.mr-1 時
          b-form-select.mr-1.mb-2(v-model="endMin" :options="endMinOptions" style="max-width: 70px;")
          span.mr-1 分
      .d-flex.flex-column(v-if="outing.type == 'stayingOut'")
        .d-flex.flex-row.align-items-center.flex-wrap
          b-form-select.mr-1.mb-2(v-model="stayingCount" :options="stayingCountOptions" style="max-width: 230px;")
          b-form-select.mr-1.mb-2(v-model="endHour" :options="endHourOptions" style="max-width: 70px;")
          span.mr-1 時
          b-form-select.mr-1.mb-2(v-model="endMin" :options="endMinOptions" style="max-width: 70px;")
          span.mr-1 分

    //- location
    .mb-1
      span.key-name 主な外出場所
      RequireInput
    .mb-3
      b-form-input(v-model="outing.location" id="location" name="location"
        placeholder="主な外出場所" maxlength="100" @focus="hideFooter" @blur="showFooter"
        v-validate="{ required: true, max: 100 }" aria-describedby="location" data-vv-as="主な外出場所")

    //- applicantFamily
    .mb-0
      span.key-name 申請者（続柄・電話番号）
    .mb-3
      span {{ _applicantFamily }}

    //- applicantFamily
    .mb-1
      span.key-name お迎えに来る方
      RequireInput
    .mb-3
      b-form-select(v-model="outing.applicantPickup" :options="_applicantPickupOptions")
    //- 
    .pickup-person(v-if="!outing.applicantPickup")
      //- name
      .mb-1
        span.key-name お迎えに来る方（氏名）
        RequireInput
      .mb-3
        b-form-input(v-model="outing.pickupPerson.name" id="pickup-person-name" name="pickup-person-name"
          placeholder="お迎えに来る方（氏名）" maxlength="32" @focus="hideFooter" @blur="showFooter"
          v-validate="{ required: true, max: 32 }" aria-describedby="pickup-person-name" data-vv-as="お迎えに来る方（氏名）")
      //- relation
      .mb-1
        span.key-name お迎えに来る方（続柄）
        RequireInput
      .mb-3
        b-form-input(v-model="outing.pickupPerson.relation" id="pickup-person-relation" name="pickup-person-relation"
          placeholder="お迎えに来る方（続柄）" maxlength="10" @focus="hideFooter" @blur="showFooter"
          v-validate="{ required: true, max: 10 }" aria-describedby="pickup-person-relation" data-vv-as="お迎えに来る方（続柄）")

    //- selectedVehicle
    .selected-vehicle(v-if="_showSelectedVehicle")
      .mb-1
        span.key-name 外出手段
        RequireInput
      .mb-3
        b-form-input(v-model="outing.selectedVehicle" id="selected-vehicle" name="selected-vehicle"
          placeholder="外出手段" maxlength="100" @focus="hideFooter" @blur="showFooter"
          v-validate="{ required: true, max: 100 }" aria-describedby="selected-vehicle" data-vv-as="外出手段")

    //- needsMeals
    .mb-0
      span.key-name 施設での食事
    .mb-3
      OutingEditNeedsMealsTable(v-if="_showOutingNeedsMeal" v-model="_needsMealItems" :fields="needsMealFields")

    //- isSharedOuting
    .mb-0
      span.key-name 届出を他の同一利用者家族にも共有する
    .mb-3
      b-form-select(v-model="outing.isSharedOuting" :options="_isSharedOutingOptions")

    //- text
    .mb-0
      span.key-name 家族からの連絡事項
    .mb-3
      b-form-textarea(v-model="outing.text" id="text" name="text" placeholder="例：家族からの連絡事項をご記載ください。"
        rows="6" max-rows="6" maxlength="1000" @focus="hideFooter" @blur="showFooter"
        v-validate="{ max: 1000 }" aria-describedby="text" data-vv-as="家族からの連絡事項")

    //- error message
    .mb-4(v-if="errorMessage != ''")
      span.error-message {{ errorMessage }}

    //- buttons
    .mb-3
      ValidationAlert(v-model="showValidationAlert")
    .d-flex.flex-row.justify-content-center
      b-button.btn.ok-btn.mr-2(@click="onUpdate(outing)") 変更
      b-button.btn.back-btn(@click="onBack") キャンセル

  //- loading modal
  Loading(:isBusy="isBusy" :message="loadingMessage")

  //- update modals
  OkCancelModal(v-model="showConfirmModal" :title="confirmModalTitle" @ok="onUpdateConfirmOk(outing)")
  OkModal(v-model="showOkModal" title="更新に成功しました。" @ok="onBack")
</template>

<script lang="ts">
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { MobileUrl } from "@/commons/constants/MobileUrl";
import { errorHandle } from "@/errorHandler";

import SystemError from "@/commons/models/SystemError";
import OutingsService, { InputBy, NeedsMeal, OutingAvailableDatesGetModel, OutingGetModel, OutingPatchModel, OutingType } from "@/commons/services/Outings";
import OutingSettingsService, { OutingSettingGetModel } from "@/commons/services/OutingSettings";

import Loading from "@/mobile/basics/Loading.vue";
import ValidationAlert from "@/mobile/basics/ValidationAlertByValidator.vue";
import RequireInput from "@/mobile/basics/RequireInput.vue";
import OkCancelModal from "@/mobile/basics/OkCancelModal.vue";
import OkModal from "@/mobile/basics/OkModal.vue";
import MessageModal from "@/mobile/components/modals/MessageModal.vue";
import MessageConfirmModal from "@/mobile/components/modals/MessageConfirmModal.vue";
import OutingEditNeedsMealsTable, { OutingEditNeedsMealsTableField, OutingEditNeedsMealsTableItem } from "@/mobile/components/tables/OutingEditNeedsMealsTable.vue";

/**
 * ### 外出外泊届け詳細コンポーネント
 */
@Component({
  components: {
    Loading,
    ValidationAlert,
    RequireInput,
    OkCancelModal,
    OkModal,
    MessageModal,
    MessageConfirmModal,
    OutingEditNeedsMealsTable
  },
  $_veeValidate: { validator: "new" }
})
export default class ReservationDetail extends Vue {
  /** 外出外泊サービス */
  @Inject("OutingsService") outingsService!: OutingsService;
  /** 外出外泊設定サービス */
  @Inject("OutingSettingsService") outingSettingsService!: OutingSettingsService;

  /** ローディングモーダル表示可否 */
  isBusy: boolean = false;
  /** ローディングモーダルメッセージ */
  loadingMessage: string = "";
  /** 初期化が終わったかどうか（Watchの判定で使用する） */
  isInitialized: boolean = false;

  /** エラーメッセージ */
  errorMessage: string = "";
  /** 日付用エラーメッセージ */
  outingDateErrorMessages: Array<string> = [];
  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 外出外泊届け */
  outing: OutingGetModel | null = null;
  /** 外出外泊届け設定 */
  setting: OutingSettingGetModel | null = null;
  /** 外出外泊可能日時（開始） */
  outingAvailableStartDates: OutingAvailableDatesGetModel | null = null;
  /** 外出外泊可能日時（終了） */
  outingAvailableEndDates: OutingAvailableDatesGetModel | null = null;

  /** 開始年 */
  startYear: string = "";
  /** 開始月 */
  startMonth: string = "";
  /** 開始月の選択肢 */
  startMonthOptions: Array<{ text: string; value: string | null }> = [];
  /** 開始日 */
  startDate: string = "";
  /** 開始日の選択肢 */
  startDateOptions: Array<{ text: string; value: string | null }> = [];
  /** 開始時 */
  startHour: string = "";
  /** 開始時の選択肢 */
  startHourOptions: Array<{ text: string; value: string | null }> = [];
  /** 開始分 */
  startMin: string = "";
  /** 開始分の選択肢 */
  startMinOptions: Array<{ text: string; value: string | null }> = [];
  /** 宿泊日数 */
  stayingCount: string = "";
  /** 宿泊日数の選択肢 */
  stayingCountOptions: Array<{ text: string; value: string | null }> = [];
  /** 終了時 */
  endHour: string = "";
  /** 終了時の選択肢 */
  endHourOptions: Array<{ text: string; value: string | null }> = [];
  /** 終了分 */
  endMin: string = "";
  /** 終了分の選択肢 */
  endMinOptions: Array<{ text: string; value: string | null }> = [];

  /** 外出外泊開始日の食事が必要かどうか */
  startDateNeedsMeal: NeedsMeal = {
    breakfast: true,
    lunch: true,
    snack: true,
    dinner: true
  };
  /** 外出外泊終了日の食事が必要かどうか */
  endDateNeedsMeal: NeedsMeal | null | undefined = {
    breakfast: true,
    lunch: true,
    snack: true,
    dinner: true
  };

  /** 食事等のテーブル列 */
  needsMealFields: Array<OutingEditNeedsMealsTableField> = [];

  /** 更新確認モーダル表示可否 */
  showConfirmModal: boolean = false;
  /** 更新確認モーダルタイトル */
  confirmModalTitle: string = "";
  /** 更新完了モーダル表示可否 */
  showOkModal: boolean = false;

  /** ### 届出種類 */
  get _typeName(): string {
    if (!this.outing) {
      return "";
    }
    return this.outing.type == OutingType.GOING_OUT ? "外出" : this.outing.type == OutingType.STAYING_OUT ? "外泊" : "";
  }
  /** 届け出状態 */
  get _inputType(): string {
    if (this.outing && this.outing.inputBy == InputBy.FACILITY) {
      return "代理届け";
    } else {
      return "本人届け";
    }
  }
  /** ### 開始年の選択肢 */
  get _startYearOptions(): Array<{ text: string; value: string | null }> {
    const years: Array<{ text: string; value: string }> = [];
    for (let i = 0; i < 2; i++) {
      const date: Date = new Date();
      date.setFullYear(date.getFullYear() + i);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;
      years.push({ text: `${date.getFullYear()}（${jpYear}）`, value: String(date.getFullYear()) });
    }
    return years;
  }
  /** ### 申請者 */
  get _applicantFamily(): string {
    if (!this.outing) {
      return "";
    }
    return `${this.outing.applicantFamilyInfo.name}（${this.outing.applicantFamilyInfo.relation}・${this.outing.applicantFamilyInfo.tel}）`;
  }
  /** お迎えに来る方 */
  get _applicantPickupOptions(): Array<{ text: string; value: boolean | null }> {
    return [
      { value: true, text: "申請者と同じ" },
      { value: false, text: "申請者以外" }
    ];
  }
  /** 外出手段 */
  get _showSelectedVehicle(): boolean {
    if (!this.outing || !this.setting) {
      return false;
    } else {
      return this.setting.useSelectedVehicle;
    }
  }
  /** ### 食事キャンセル情報入力を表示するか否か */
  get _showOutingNeedsMeal(): boolean {
    if (!this.outing || !this._inputedStartAndEndDatetime) {
      return false;
    } else {
      return true;
    }
  }
  get _inputedStartAndEndDatetime(): boolean {
    // 共通部分が入力されているかを判定
    const inputedDatetime =
      this.startYear != "" && this.startMonth != "" && this.startDate != "" && this.startHour != "" && this.startMin != "" && this.endHour != "" && this.endMin != ""
        ? true
        : false;
    // 外出の場合はそのまま返す
    if (this.outing && this.outing.type == OutingType.GOING_OUT) {
      return inputedDatetime;
    }
    // 外泊の場合は宿泊日数が入力さているかも合わせて返す
    else if (this.outing && this.outing.type == OutingType.STAYING_OUT) {
      return inputedDatetime && this.stayingCount != "";
    }
    return false;
  }
  /** ### 食事キャンセル行情報 */
  get _needsMealItems(): Array<OutingEditNeedsMealsTableItem> {
    if (!this.outing) {
      return [];
    }
    // 開始日時を作成する
    const startDate = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDate), Number(this.startHour), Number(this.startMin));
    const startDatetime = this.$dateUtil.convertDateToNumber(startDate, "yyyymmddhhMM00000");
    // 終了日時を作成する
    startDate.setDate(startDate.getDate() + Number(this.stayingCount)); // 開始日に宿泊数を加算
    startDate.setHours(Number(this.endHour)); // 終了時を設定
    startDate.setMinutes(Number(this.endMin)); // 終了分を設定
    const endDatetime = this.$dateUtil.convertDateToNumber(startDate, "yyyymmddhhMM00000");

    const items: Array<OutingEditNeedsMealsTableItem> = [];
    items.push({
      datetime: startDatetime,
      needsMeal: this.startDateNeedsMeal
    });
    if (this.outing.type == OutingType.STAYING_OUT) {
      items.push({
        datetime: endDatetime,
        needsMeal: this.endDateNeedsMeal as NeedsMeal
      });
    }

    return items;
  }
  /** 同一利用者の家族に共有するか否か */
  get _isSharedOutingOptions(): Array<{ text: string; value: boolean | null }> {
    return [
      { value: true, text: "はい" },
      { value: false, text: "いいえ" }
    ];
  }

  /**
   * ### 開始年の値更新を監視する
   *
   * - 月以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 開始月のセレクトボックスの選択肢を更新する
   */
  @Watch("startYear")
  public changeStartYear(newValue: string): void {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.startMonth = "";
    this.startDate = "";
    this.startHour = "";
    this.startMin = "";
    this.stayingCount = "";
    this.endHour = "";
    this.endMin = "";

    this.outingDateErrorMessages = [];

    const startMonthOptions: Array<{ text: string; value: string | null }> = this.createStartMonthOptions(Number(newValue));
    this.startMonthOptions = startMonthOptions;

    if (startMonthOptions.length == 0) {
      this.outingDateErrorMessages.push("選択した年は外出外泊届けが出来ません。他の年を選択してください。");
    }

    return;
  }

  /**
   * ### 開始月の値更新を監視する
   *
   * - 開始日以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 開始日のセレクトボックスの選択肢を更新する
   */
  @Watch("startMonth")
  public async changeStartMonth(newValue: string): Promise<void> {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startDate = "";
      this.startHour = "";
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessages = [];

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const startDateOptions: Array<{ text: string; value: string | null }> = await this.createStartDateOptions(Number(this.startYear), Number(newValue));
      this.startDateOptions = startDateOptions;

      if (startDateOptions.length == 0) {
        this.outingDateErrorMessages.push("選択した月は外出外泊届けが出来ません。他の月を選択してください。");
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }
    return;
  }

  /**
   * ### 開始日の値更新を監視する
   *
   * - 開始時以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 開始時のセレクトボックスの選択肢を更新する
   */
  @Watch("startDate")
  public changeStartDate(newValue: string): void {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startHour = "";
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessages = [];

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const startHourOptions: Array<{ text: string; value: string | null }> = this.createStartHourOptions(Number(newValue));
      this.startHourOptions = startHourOptions;

      if (startHourOptions.length == 0) {
        this.outingDateErrorMessages.push("選択した日は外出外泊届けが出来ません。他の日を選択してください。");
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }
    return;
  }

  /**
   * ### 開始時の値更新を監視する
   *
   * - 開始分以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 分のセレクトボックスの選択肢を更新する
   */
  @Watch("startHour")
  public changeStartHour(newValue: string): void {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessages = [];

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const startMinOptions: Array<{ text: string; value: string | null }> = this.createStartMinOptions(Number(this.startDate), Number(newValue));
      this.startMinOptions = startMinOptions;

      if (startMinOptions.length == 0) {
        this.outingDateErrorMessages.push("選択した開始時は外出外泊届けが出来ません。他の開始時を選択してください。");
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 開始分の値更新を監視する
   *
   * - 宿泊数以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 外出の場合は終了日、外泊の場合は宿泊数のセレクトボックスの選択肢を更新する
   */
  @Watch("startMin")
  public async changeStartMin(newValue: string): Promise<void> {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessages = [];

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      // 外出の場合は終了日の選択肢を更新する
      if (this.outing?.type == OutingType.GOING_OUT) {
        const endHourOptions: Array<{ text: string; value: string | null }> = await this.createEndHourOptions();
        this.endHourOptions = endHourOptions;

        if (endHourOptions.length == 0) {
          this.outingDateErrorMessages.push("選択した開始分は外出外泊届けが出来ません。他の開始分を選択してください。");
        }
      }
      // 外泊の場合は宿泊数の選択肢を更新する
      else if (this.outing?.type == OutingType.STAYING_OUT) {
        const startDatetime = this.$dateUtil.convertDateToNumber(
          new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDate), Number(this.startHour), Number(this.startMin)),
          "yyyymmdd000000000"
        );
        const stayingCountOptions: Array<{ text: string; value: string | null }> = await this.createStayingCountOptions(startDatetime);
        this.stayingCountOptions = stayingCountOptions;

        if (stayingCountOptions.length == 0) {
          this.outingDateErrorMessages.push("選択した開始分は外出外泊届けが出来ません。他の開始分を選択してください。");
        }
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 宿泊数の値更新を監視する
   *
   * - 終了時以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 終了時のセレクトボックスの選択肢を更新する
   */
  @Watch("stayingCount")
  public async changeStayingCounts(newValue: string): Promise<void> {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessages = [];

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const endHourOptions: Array<{ text: string; value: string | null }> = await this.createEndHourOptions();
      this.endHourOptions = endHourOptions;

      if (endHourOptions.length == 0) {
        this.outingDateErrorMessages.push("選択した宿泊数は外出外泊届けが出来ません。他の宿泊数を選択してください。");
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 終了時の値更新を監視する
   *
   * - 終了分以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 終了分のセレクトボックスの選択肢を更新する
   */
  @Watch("endHour")
  public changeEndHour(newValue: string): void {
    // 更新対象の外出外泊届け、外出外泊設定が未取得の場合は処理をスキップする
    // 初期化処理が終わるまでは処理をスキップする
    if (!this.outing || !this.setting || !this.isInitialized) {
      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.endMin = "";

      this.outingDateErrorMessages = [];

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const endMinOptions: Array<{ text: string; value: string | null }> = this.createEndMinOptions(newValue);
      this.endMinOptions = endMinOptions;

      if (endMinOptions.length == 0) {
        // 外出
        if (this.outing?.type == OutingType.GOING_OUT) {
          this.outingDateErrorMessages.push("選択した終了時は外出外泊届けが出来ません。他の終了時を選択してください。");
        }
        // 外泊
        else if (this.outing?.type == OutingType.STAYING_OUT) {
          this.outingDateErrorMessages.push("選択した終了時は外出外泊届けが出来ません。他の終了時を選択してください。");
        }
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報を作成する
   */
  async createView(): Promise<void> {
    this.loadingMessage = "読込み中";
    this.isBusy = true;

    const setting: OutingSettingGetModel = await this.getOutingSetting();
    this.setting = setting;
    const needsMealFields = this.createNeedsMealFields(setting);
    this.needsMealFields = needsMealFields;

    const id: string = this.$route.params.id;
    const outing: OutingGetModel = await this.getOuting(Number(id));
    this.setOuting(outing, setting);

    // 初期化が終わったことを格納する
    // Watchが動かないように、2秒待つ
    await this.$timerUtil.setTimeout(2000);
    this.isInitialized = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### 外出外泊届け設定取得
   */
  async getOutingSetting(): Promise<OutingSettingGetModel> {
    const response: OutingSettingGetModel = await this.outingSettingsService.get(userStore);
    return response;
  }

  /**
   * ### テーブル列名を作成する
   */
  createNeedsMealFields(setting: OutingSettingGetModel): Array<OutingEditNeedsMealsTableField> {
    const fields: Array<OutingEditNeedsMealsTableField> = [];
    fields.push({ key: "date", label: "日", sortable: false, sortDirection: "desc", class: "date text-center" });

    // 食事列は設定に応じて表示／非表示を切り替える
    if (setting.useNeedsMeal.breakfast) {
      fields.push({ key: "breakfast", label: "朝食", sortable: false, sortDirection: "desc", class: "meal-name breakfast text-center" });
    }
    if (setting.useNeedsMeal.lunch) {
      fields.push({ key: "lunch", label: "昼食", sortable: false, sortDirection: "desc", class: "meal-name lunch text-center" });
    }
    if (setting.useNeedsMeal.snack) {
      fields.push({ key: "snack", label: "おやつ", sortable: false, sortDirection: "desc", class: "meal-name snack text-center" });
    }
    if (setting.useNeedsMeal.dinner) {
      fields.push({ key: "dinner", label: "夕食", sortable: false, sortDirection: "desc", class: "meal-name dinner text-center" });
    }
    return fields;
  }

  /**
   * ### 外出外泊届けを取得する
   */
  async getOuting(outingId: number): Promise<OutingGetModel> {
    const response: OutingGetModel = await this.outingsService.get(userStore, outingId);
    return response;
  }

  /**
   * ### 外出外泊届け情報から画面表示用の情報を作成して格納する
   */
  public async setOuting(outing: OutingGetModel, setting: OutingSettingGetModel): Promise<void> {
    this.outing = outing;

    // 同一利用者の家族に共有するか否か。v3.38.0以前はundefinedなので、falseをセットする
    this.outing.isSharedOuting = outing.isSharedOuting != undefined ? outing.isSharedOuting : false;

    // 外出または外泊の開始・終了日時を格納する
    this.startYear = this.$dateUtil.convertNumberToString(outing.startDatetime, "yyyy");

    this.startMonthOptions = this.createStartMonthOptions(Number(this.startYear));
    this.startMonth = this.$dateUtil.convertNumberToString(outing.startDatetime, "mm", false);

    this.startDateOptions = await this.createStartDateOptions(Number(this.startYear), Number(this.startMonth));
    this.startDate = this.$dateUtil.convertNumberToString(outing.startDatetime, "dd", false);

    this.startHourOptions = this.createStartHourOptions(Number(this.startDate));
    this.startHour = this.$dateUtil.convertNumberToString(outing.startDatetime, "hh", false);

    this.startMinOptions = this.createStartMinOptions(Number(this.startDate), Number(this.startHour));
    this.startMin = this.$dateUtil.convertNumberToString(outing.startDatetime, "MM", false);

    if (outing.type == OutingType.STAYING_OUT) {
      // 宿泊日数を計算する
      this.stayingCount = this.calculateStayingCount(outing);
      // 宿泊日数選択肢を計算する
      this.stayingCountOptions = await this.createStayingCountOptions(outing.startDatetime);
    }

    this.endHourOptions = await this.createEndHourOptions();
    this.endHour = this.$dateUtil.convertNumberToString(outing.endDatetime, "hh", false);

    this.endMinOptions = this.createEndMinOptions(this.endHour);
    this.endMin = this.$dateUtil.convertNumberToString(outing.endDatetime, "MM", false);

    // お迎え（自由記述）が存在しない場合は初期値を作成する
    if (!outing.pickupPerson) {
      outing.pickupPerson = {
        name: "",
        relation: "",
        tel: ""
      };
    }
    // 外出手段が存在しない場合は初期値を作成する
    if (!outing.selectedVehicle) {
      outing.selectedVehicle = "";
    }
    // 開始日の食事情報を格納する
    // 設定で使用しない食事は「しない」で上書きする
    this.startDateNeedsMeal = outing.startDateNeedsMeal;
    this.startDateNeedsMeal = this.updateDateNeedsMealBySetting(this.startDateNeedsMeal, setting);

    // 終了日の食事情報を格納する
    // 食事等が存在しない場合は初期値を作成する
    // 設定で使用しない食事は「しない」で上書きする
    if (outing.endDateNeedsMeal) {
      this.endDateNeedsMeal = outing.endDateNeedsMeal;
      this.endDateNeedsMeal = this.updateDateNeedsMealBySetting(this.endDateNeedsMeal, setting);
    } else {
      const endDateNeedsMeal = {
        breakfast: true,
        lunch: true,
        snack: true,
        dinner: true
      };
      this.endDateNeedsMeal = this.updateDateNeedsMealBySetting(endDateNeedsMeal, setting);
    }
    return;
  }

  /**
   * ### 開始月選択肢を作成する
   */
  public createStartMonthOptions(year: number): Array<{ text: string; value: string | null }> {
    const date: Date = new Date();
    const currentYear: number = date.getFullYear();
    const currentMonth: number = date.getMonth();
    const monthOptions: Array<{ text: string; value: string | null }> = [];

    for (let i = 0; i < 12; i++) {
      if ((currentYear == year && currentMonth <= i) || currentYear < year) {
        monthOptions.push({
          text: String(i + 1),
          value: String(i + 1)
        });
      }
    }

    return monthOptions;
  }

  /**
   * ### 開始日付選択肢を作成する
   */
  public async createStartDateOptions(year: number, month: number): Promise<Array<{ text: string; value: string | null }>> {
    if (!this.outing) {
      return [];
    }

    const outingAvailableStartDates = await this.getAvailableStartDates(this.outing, year, month);
    const dateOptions: Array<{ text: string; value: string | null }> = [];
    for (const availableDate in outingAvailableStartDates) {
      const slicedAvailableDate = availableDate.slice(6, 9);
      // 0埋めされているので、数値にしてから文字列に戻す
      dateOptions.push({ text: Number(slicedAvailableDate).toString(), value: Number(slicedAvailableDate).toString() });
    }
    this.outingAvailableStartDates = outingAvailableStartDates;

    return dateOptions;
  }

  public async getAvailableStartDates(outing: OutingGetModel, year: number, month: number): Promise<OutingAvailableDatesGetModel> {
    const splitedResidentsSortKey: string[] = outing.residentsSortKey.split("_");
    const params: { type: string; residentId: number; year: number; month: number } = {
      type: this.outing?.type as OutingType,
      residentId: Number(splitedResidentsSortKey[0]),
      year: year,
      month: month
    };
    const queryParams: { exclusionid: number } = { exclusionid: outing.id };
    const response: OutingAvailableDatesGetModel = await this.outingsService.getAvailableStartDates(userStore, params, queryParams);
    return response;
  }

  /**
   * ### 開始時間選択肢を作成する
   */
  public createStartHourOptions(day: number): Array<{ text: string; value: string | null }> {
    if (!this.outing || !this.outingAvailableStartDates) {
      return [];
    }

    const hourOptions: Array<{ text: string; value: string | null }> = [];
    for (const availableDate in this.outingAvailableStartDates) {
      const slicedAvailableDate = availableDate.slice(6, 9);
      if (Number(slicedAvailableDate) == day) {
        for (const availableHour in this.outingAvailableStartDates[availableDate]) {
          hourOptions.push({
            text: availableHour,
            value: availableHour
          });
        }
      }
    }

    return hourOptions;
  }

  /**
   * ### 開始分選択肢を作成する
   */
  public createStartMinOptions(day: number, hour: number): Array<{ text: string; value: string | null }> {
    if (!this.outing || !this.outingAvailableStartDates) {
      return [];
    }

    let mins: Array<string> | null = null;
    for (const availableDate in this.outingAvailableStartDates) {
      const slicedAvailableDate = availableDate.slice(6, 9);
      if (Number(slicedAvailableDate) == day) {
        for (const availableHour in this.outingAvailableStartDates[availableDate]) {
          if (Number(availableHour) == hour) {
            mins = this.outingAvailableStartDates[availableDate][availableHour];
            break;
          }
        }
      }
    }
    if (mins) {
      const minOptions: Array<{ text: string; value: string | null }> = [];
      for (const min of mins as string[]) {
        minOptions.push({
          text: min,
          value: min
        });
      }
      return minOptions;
    } else {
      return [];
    }
  }

  /**
   * ### 宿泊日数を計算する
   */
  private calculateStayingCount(outing: OutingGetModel): string {
    const startDate = this.$dateUtil.convertNumberToDate(outing.startDatetime);
    const endDate = this.$dateUtil.convertNumberToDate(outing.endDatetime);
    return String(this.$dateUtil.diffDate(startDate, endDate));
  }

  /**
   * ### 宿泊日数選択肢を作成する
   */
  private async createStayingCountOptions(startDatetime: number): Promise<Array<{ text: string; value: string | null }>> {
    if (!this.outing) {
      return [];
    }

    const outingAvailableEndDates = await this.getAvailableEndDates(this.outing, startDatetime);
    const options: Array<{ text: string; value: string | null }> = [];
    const startDate = this.$dateUtil.convertNumberToDate(startDatetime);
    for (const availableDate in outingAvailableEndDates) {
      const currentDate = this.$dateUtil.convertNumberToDate(Number(`${availableDate}000000000`));
      const stayCount = this.$dateUtil.diffDate(startDate, currentDate);
      options.push({
        text: `${stayCount}泊（${this.$dateUtil.convertNumberToString(Number(`${availableDate}000000000`), "yyyy年mm月dd日")}）`,
        value: String(stayCount)
      });
    }
    this.outingAvailableEndDates = outingAvailableEndDates;

    return options;
  }

  public async getAvailableEndDates(outing: OutingGetModel, datetime: number): Promise<OutingAvailableDatesGetModel> {
    const splitedResidentsSortKey: string[] = outing.residentsSortKey.split("_");
    const params: { type: string; residentId: number; datetime: string } = {
      type: this.outing?.type as OutingType,
      residentId: Number(splitedResidentsSortKey[0]),
      datetime: this.$dateUtil.convertNumberToString(datetime, "yyyymmddhhMM")
    };
    const queryParams: { exclusionid: number } = { exclusionid: outing.id };
    const response: OutingAvailableDatesGetModel = await this.outingsService.getAvailableEndDates(userStore, params, queryParams);
    return response;
  }

  /**
   * ### 終了時間選択肢を作成する
   */
  public async createEndHourOptions(): Promise<Array<{ text: string; value: string | null }>> {
    if (!this.outing) {
      return [];
    }

    // 選択肢作成対象の日付を作成する
    // 更に外出の場合、終了時間選択肢の情報を取得する必要がある（外泊の場合は宿泊日数選択肢の作成時に取得しているので取得不要）
    let day = null;
    if (this.outing.type == OutingType.GOING_OUT) {
      const startDate = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDate), Number(this.startHour), Number(this.startMin));
      const startDatetime = this.$dateUtil.convertDateToNumber(startDate, "yyyymmddhhMM00000");
      const outingAvailableEndDates = await this.getAvailableEndDates(this.outing, startDatetime);
      this.outingAvailableEndDates = outingAvailableEndDates;

      day = this.$dateUtil.convertDateToString(startDate, "yyyymmdd");
    } else if (this.outing.type == OutingType.STAYING_OUT) {
      const startDate = new Date(
        Number(this.startYear),
        Number(this.startMonth) - 1,
        Number(this.startDate) + Number(this.stayingCount),
        Number(this.startHour),
        Number(this.startMin)
      );
      day = this.$dateUtil.convertDateToString(startDate, "yyyymmdd");
      await this.$timerUtil.setTimeout(1); // asyncのfunctionでawaitしないと描画が止まる問題があるので1msawaitする
    } else {
      return [];
    }

    const hourOptions: Array<{ text: string; value: string | null }> = [];
    for (const availableDate in this.outingAvailableEndDates) {
      if (availableDate == day) {
        for (const availableHour in this.outingAvailableEndDates[availableDate]) {
          hourOptions.push({
            text: availableHour,
            value: availableHour
          });
        }
      }
    }

    return hourOptions;
  }

  /**
   * ### 終了分選択肢を作成する
   */
  public createEndMinOptions(hour: string): Array<{ text: string; value: string | null }> {
    const startDate = new Date(
      Number(this.startYear),
      Number(this.startMonth) - 1,
      Number(this.startDate) + Number(this.stayingCount),
      Number(this.startHour),
      Number(this.startMin)
    );
    const day = this.$dateUtil.convertDateToString(startDate, "yyyymmdd");

    let mins: Array<string> | null = null;
    for (const availableDate in this.outingAvailableEndDates) {
      if (availableDate == day) {
        for (const availableHour in this.outingAvailableEndDates[availableDate]) {
          if (availableHour == hour) {
            mins = this.outingAvailableEndDates[availableDate][availableHour];
            break;
          }
        }
      }
    }
    if (mins) {
      const minOptions: Array<{ text: string; value: string | null }> = [];
      for (const min of mins as string[]) {
        minOptions.push({
          text: min,
          value: min
        });
      }
      return minOptions;
    } else {
      return [];
    }
  }

  /** ### 設定の「食事の使用有無」で「使用しない」ものは強制的に食事しないに更新する */
  updateDateNeedsMealBySetting(needsMeal: NeedsMeal, setting: OutingSettingGetModel): NeedsMeal {
    if (setting.useNeedsMeal.breakfast == false) {
      needsMeal.breakfast = false;
    }
    if (setting.useNeedsMeal.lunch == false) {
      needsMeal.lunch = false;
    }
    if (setting.useNeedsMeal.snack == false) {
      needsMeal.snack = false;
    }
    if (setting.useNeedsMeal.dinner == false) {
      needsMeal.dinner = false;
    }
    return needsMeal;
  }

  /**
   * ### 更新確認モーダルを表示する
   */
  async onUpdate(outing: OutingGetModel): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult == true) {
      this.showValidationAlert = false;

      const residentName = `${outing.targetResidentInfo.name}（${outing.targetResidentInfo.roomName}）`;
      const familyName = `${outing.applicantFamilyInfo.name}（${outing.applicantFamilyInfo.relation}）`;
      const message: string = `${residentName}様の${familyName}の外出外泊届けを更新しますか？`;
      this.confirmModalTitle = message;
      this.showConfirmModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### 外出外泊届けを更新する
   */
  async onUpdateConfirmOk(outing: OutingGetModel): Promise<void> {
    this.loadingMessage = "更新中";
    this.isBusy = true;

    try {
      const id: number = Number(this.$route.params.id);
      const requestBody: OutingPatchModel = await this.createRequestBody(outing);
      await this.outingsService.patch(userStore, id, requestBody);

      this.showOkModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 外出外泊届け更新パラメータ作成
   */
  public createRequestBody(outing: OutingGetModel): OutingPatchModel {
    const requestBody: OutingPatchModel = {
      /** 外出、外泊種別 */
      type: outing.type,
      /** 外出外泊開始日時 */
      startDatetime: this.createRequestStartDatetime(),
      /** 外出外泊終了日時 */
      endDatetime: this.createRequestEndDatetime(),
      /** 主な外出場所（100文字） */
      location: outing.location,
      /** お迎え。申請者本人（true）、申請者以外（false） */
      applicantPickup: outing.applicantPickup,
      /** お迎え（自由記述） */
      pickupPerson: outing.applicantPickup
        ? null
        : {
            name: outing.pickupPerson?.name ? outing.pickupPerson?.name : "",
            relation: outing.pickupPerson?.relation ? outing.pickupPerson?.relation : "",
            tel: outing.pickupPerson?.tel ? outing.pickupPerson?.tel : ""
          },
      /** 外出手段 */
      selectedVehicle: outing.selectedVehicle,
      /** 外出外泊開始日の食事が必要かどうか */
      startDateNeedsMeal: outing.startDateNeedsMeal,
      /** 外出外泊終了日の食事が必要かどうか */
      endDateNeedsMeal: outing.type == OutingType.STAYING_OUT ? outing.endDateNeedsMeal : null,
      /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
      isSharedOuting: outing.isSharedOuting != undefined ? outing.isSharedOuting : false,
      /** 連絡事項（1000文字） */
      text: outing.text ? outing.text : "",

      /** レコード更新日 */
      updated: outing.updated
    };

    return requestBody;
  }

  /**
   * ### リクエスト用の終了日時を作成する
   */
  public createRequestEndDatetime(): number {
    // 外出
    if (this.outing?.type == OutingType.GOING_OUT) {
      const date = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDate), Number(this.endHour), Number(this.endMin));
      return this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMM00000");
    }
    // 外泊
    else if (this.outing?.type == OutingType.STAYING_OUT) {
      const date = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDate), Number(this.endHour), Number(this.endMin));
      date.setDate(date.getDate() + Number(this.stayingCount));
      return this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMM00000");
    }
    return 0;
  }

  /**
   * ### リクエスト用の開始日時を作成する
   */
  public createRequestStartDatetime(): number {
    const date = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDate), Number(this.startHour), Number(this.startMin));
    return this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMM00000");
  }

  /**
   * ### キャンセルボタン押下イベント
   */
  onBack(): void {
    this.$router.push({ name: MobileUrl.OutingDetail, params: { id: this.$route.params.id } });
    return;
  }

  /**
   * ### フッターを表示する
   */
  showFooter(): void {
    this.$emit("updateShowFooter", true);
    return;
  }

  /**
   * ### フッターを非表示にする
   */
  hideFooter(): void {
    this.$emit("updateShowFooter", false);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_mixin.scss";
@import "../../../styles/mobile/_colors.scss";

#outing-detail {
  .sunday {
    color: $font-sunday;
  }
  .saturday {
    color: $font-saturday;
  }

  .edit-text {
    color: $font-base;
    opacity: 0.5;
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
  }
  .edit-text:hover {
    opacity: 0.75;
  }
  .outing-text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .status-consented {
    color: $font-disable;
    font-weight: bold;
  }
  .status-no-consented {
    color: $font-strong;
    font-weight: bold;
  }
}
</style>
